import React from "react";
import PropTypes from "prop-types";

import Head from "../components/Head";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "../../scss/main.scss";

const TemplateWrapper = ({ children }) => (
	<div>
		<Head />
		<Header />
		<main className="site-main">
			<div className="wrap">{children()}</div>
		</main>
		<Footer />
	</div>
);

TemplateWrapper.propTypes = {
	children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js